import { useLayoutEffect } from 'react'
import { useLocation } from 'react-router-dom'

export default function ScrollToTop() {
  const { pathname } = useLocation()

  useLayoutEffect(() => {
    const targets = [
      document.scrollingElement,          
      document.documentElement,           
      document.body,                      
      document.querySelector('.App'),     
      document.getElementById('root')    
    ].filter(Boolean)

 
    requestAnimationFrame(() => {
      targets.forEach(el => { el.scrollTop = 0; el.scrollLeft = 0 })
      window.scrollTo(0, 0)
    })
  }, [pathname])

  return null
}
